/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-05-28 11:38:13
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-08-20 10:38:24
 * @Notes:
 */

import Axios from "utils/request";
import { RESOURCES_API_URL } from "utils/config";
import { RootDispatch } from "store";
import { buildTreeData } from "utils/helper";

const getFolders = () => {
  return Axios({ url: "folder/init" }).then((res: any) => {
    return res;
  });
};

const createDir = async (data: any) => {
  return await Axios({
    url: RESOURCES_API_URL + "folder/add",
    method: "post",
    data,
  });
  // return Axios({ url: "folder/add", method: "post", data });
  // return await promiseAgent({ data, url: "folder/add", method: "post" });
};

const getFolderCount = (data: any) => {
  return Axios({
    url: RESOURCES_API_URL + "folder/count",
    method: "get",
    data,
  });
};

const deleteFolder = (data) => {
  return Axios({
    url: RESOURCES_API_URL + "folder/delete",
    method: "post",
    data,
  });
};

const getQiniuUploadToken = () => {
  return Axios({ url: RESOURCES_API_URL + "resource/auth", method: "get" });
};

const checkResourceExisted = (resourceName) => {
  return Axios({
    url: RESOURCES_API_URL + "resource/check",
    method: "get",
    data: { resourceName: resourceName },
  });
};

const addResource = (data) => {
  return Axios({
    url: RESOURCES_API_URL + "resource/add",
    method: "post",
    data: data,
  });
};

const removeResourceAsync = (data) => {
  return Axios({
    url: RESOURCES_API_URL + "resource/delete",
    method: "post",
    data,
  });
};

const getResources = (data) => {
  return Axios({
    url: RESOURCES_API_URL + "resource/list",
    method: "get",
    data,
  });
};

const searchResources = (data) => {
  return Axios({
    url: RESOURCES_API_URL + "resource/search",
    method: "get",
    data,
  });
};

const searchFolders = (data) => {
  return Axios({
    url: RESOURCES_API_URL + "folder/search",
    method: "get",
    data,
  });
};

export type ImageMangerState = {
  folders: Array<Object>;
  currentFolderId: Number;
  resources: {
    // folders: Array<Object>;
    list: Array<Object>;
    total: number;
    pageSize: Number;
    pageNum: Number;
  };
  uploadToken: String;
};

export const imagemanager = {
  state: {
    folders: [],
    currentFolderId: 0,
    resources: {
      // folders: [],
      list: [],
      total: 0,
      pageSize: 20,
      pageNum: 1,
    },
    uploadToken: "",
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    setFolders(state: ImageMangerState, payload: any) {
      state.folders = payload;
      return state;
    },
    setQiniuUploadToken(state: ImageMangerState, payload: any) {
      state.uploadToken = payload;
      return state;
    },
    setResourceList(state: ImageMangerState, payload: any) {
      // state.resources.folders.push(payload.folders);
      // state.resources.list.push(payload.resources);
      // state.resources.total = payload.total;
      state.resources = payload;
      return state;
    },
    setCurrentFolderId(state: ImageMangerState, payload: any) {
      state.currentFolderId = payload;
      return state;
    },
    removeResource(state: ImageMangerState, payload: any) {
      // let newList = _.remove(state.resources.list, (item: any) => {
      //   console.log(payload, item);
      //   return payload !== item.id;
      // });
      // state.resources.list = newList;
      state.resources.list.splice(payload, 1);
      --state.resources.total;
      return state;
    },
  },
  effects: (dispatch: RootDispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async getFoldersAsync() {
      // await new Promise(resolve => setTimeout(resolve, 1000))
      const folders = await getFolders();
      const data = await buildTreeData(folders.data, "key");
      dispatch.imagemanager.setFolders(data);
    },
    async createDirAsync(data) {
      const flag = await createDir(data);
      // console.log("flag", flag);
      return flag;
    },
    // 根据文件夹名查询文件夹数量，判断文件夹是否重名
    async getFolderCountAsync(folderName) {
      const count = await getFolderCount(folderName);
      // console.log("获取");
      return count;
    },
    async deleteFolderAsync(id) {
      const flag = await deleteFolder(id);
      // console.log(flag);
      return flag;
    },
    async getQiniuUploadToken() {
      const token: any = await getQiniuUploadToken();
      dispatch.imagemanager.setQiniuUploadToken(token.data);
      // console.log(token);
      return token;
    },
    async checkResourceExisted(resourceName) {
      return await checkResourceExisted(resourceName);
    },
    async addResource(resource) {
      return await addResource(resource);
    },
    async removeResourceAsync(data) {
      return await removeResourceAsync(data);
    },
    async getResourcesAsync(data) {
      // console.log(data);
      const resources: any = await getResources(data);
      dispatch.imagemanager.setResourceList(resources.data);
      dispatch.imagemanager.setCurrentFolderId(data.fid || 0);
    },
    async searchResourcesAsync(data) {
      return await searchResources(data);
    },
    async searchFoldersAsync(data) {
      return await searchFolders(data);
    },
  }),
};
